<template>
<div class="flex flex-row my-3 overflow-x-auto flex-no-wrap">
        <div
          style="width: 450px; min-width: 450px"
          class="flex flex-row"
          v-for="(approver, i) in approvalBox"
          :key="i"
        >
          <div
            class="border mr-4 rounded p-3"
            style="width: 360px; min-width: 360px"
          >
            <div class="flex flex-row justify-between">
              <span class="flex flex-row">
                <span class="mr-3 text-muted">{{ i + 1 }}</span>
                <span class="font-bold text-xs">Approver {{ i + 1 }}</span>
              </span>
              <span
                v-if="approvalBox.length > 1"
                @click="removeApprover(i)"
                class="font-bold text-xs"
                ><img src="./partials/close.svg" alt=""
              /></span>
            </div>
            <div class="my-3 flex flex-row" v-if="approver.added">
              <b-avatar
                src="https://s3-alpha-sig.figma.com/img/080e/5e96/1f10eb911a32b0b791a3469cc3b8c5dc?Expires=1672617600&Signature=qA1IHuvuYttkbRXKjqYLt56vFGi9oYCcGuKZo9K3BNM0wrHBSjG1nN9tg6kyJmPpnz2MohM30qb2W24vnmu8UvvKPuv0-GK2OPmPVBizg1JyxzhrYzLqgx2i2e4bT~V35ncZRA1jkR5OT-0go4IhcSaI5zR~2uUZGIUegh7KWSIWwwXYx9FsQ9M-nlhS6Dhbur~mgl2IJ8qOf1f14QzDMGk6RxQvMFDH8OKhsocn8aV9oWDzHmsO2eN6wwQwsd7Bxq-beEqZkAd-9swiZQm2NuANj2AJJAK~N9gURoUGLgeemd2ed7355ZjKpgMVfMYjUIFMecDArhV9IKcnWnVDMw__&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4"
                size="48px"
              >
              </b-avatar>
              <div class="my-auto mx-3">
                <span class="font-semibold text-sm"
                  >Daniel Arubuike, Level 5</span
                >
                <br />
                <span class="text-sm text-muted"
                  >Digital Marketer, Sales & Marketing.</span
                >
              </div>
            </div>
            <div class="my-3" v-else>
              <el-select
                filterable
                v-model="state"
                style="width: 316px; display: block"
                placeholder="--Select Approver--"
              >
                <el-option label="state.name" value="state.name"> </el-option>
              </el-select>
            </div>
            <div class="mt-4">
              <hr />
            </div>
            <div class="flex mt-3 mb-0 flex-row justify-between">
              <b-form-checkbox class="text-sm"
                >Authorized Signatory</b-form-checkbox
              >
              <base-button
                v-if="approver.added"
                background="white"
                text="Change"
                color="text-primary-yellow"
              ></base-button>
              <base-button
                v-else
                background="white"
                text="Add"
                color="text-primary-yellow"
              ></base-button>
            </div>
          </div>
          <div class="my-auto flex flex-row mx-3">
            <img src="./partials/arrow.svg" alt="" />
          </div>
        </div>
        <div
          @click="addApprover()"
          class="my-auto flex flex-row text-primary-yellow"
        >
          <img src="./partials/add.svg" alt="" />
          <span class="mx-2"> Add Approver </span>
        </div>
      </div>
</template>

<script>
export default {
props:{
    approvalBox: {
        default:()=>null
      },
      index:{
        default:()=>null
      }
    },
methods:{
  addApprover() {
      this.approvalBox.push({
        name: "",
        added:false
      });
    },
    removeApprover(index) {
      this.approvalBox.splice(index, 1);
    },
}
}
</script>

<style>

</style>